(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chattitude-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var GOLD = '#D4B27A', SAGE = '#A6CB92';
  var PAW = '<svg viewBox="0 0 90 90" aria-hidden="true"><g fill="currentColor"><ellipse cx="45" cy="59" rx="19" ry="15"/><ellipse cx="17" cy="42" rx="8" ry="10.5" transform="rotate(-24 17 42)"/><ellipse cx="33" cy="21" rx="8" ry="11" transform="rotate(-8 33 21)"/><ellipse cx="57" cy="21" rx="8" ry="11" transform="rotate(8 57 21)"/><ellipse cx="73" cy="42" rx="8" ry="10.5" transform="rotate(24 73 42)"/></g></svg>';
  function rnd(a, b) { return a + Math.random() * (b - a); }

  function pawInit() {
    var hero = document.querySelector('.ct-hero,#hero');
    if (!hero || hero.getAttribute('data-pw')) return;
    hero.setAttribute('data-pw', '1');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var layer = document.createElement('div');
    layer.className = 'pw-layer';
    layer.setAttribute('aria-hidden', 'true');
    hero.appendChild(layer);

    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0 }).observe(hero);
    }
    function alive() { return document.body.contains(hero); }
    function size() { return Math.max(40, Math.min(84, hero.clientWidth * 0.052)); }

    function paw(x, y, deg, s, color, op, life) {
      if (layer.childElementCount > 120) return;
      var e = document.createElement('div');
      e.className = 'pw';
      e.style.cssText = 'left:' + x + 'px;top:' + y + 'px;--r:' + deg + 'deg;--s:' + s + 'px;--c:' + color + ';--o:' + op + ';--d:' + life + 'ms';
      e.innerHTML = PAW;
      layer.appendChild(e);
      setTimeout(function () { if (e.parentNode) e.parentNode.removeChild(e); }, life + 150);
    }

    /* Un chat traverse la page : les pattes apparaissent une à une, puis s'effacent */
    function trail() {
      if (!alive()) return;
      if (!visible || document.hidden) { setTimeout(trail, 1200); return; }
      var W = hero.clientWidth, H = hero.clientHeight, s = size(), step = s * 2.3;
      var side = Math.floor(Math.random() * 4), x0, y0, x1, y1;
      if (side === 0) { x0 = -s; y0 = rnd(.1, .9) * H; x1 = W + s; y1 = rnd(.1, .9) * H; }
      else if (side === 1) { x0 = W + s; y0 = rnd(.1, .9) * H; x1 = -s; y1 = rnd(.1, .9) * H; }
      else if (side === 2) { x0 = rnd(.1, .9) * W; y0 = H + s; x1 = rnd(.1, .9) * W; y1 = -s; }
      else { x0 = rnd(.1, .9) * W; y0 = -s; x1 = rnd(.1, .9) * W; y1 = H + s; }
      var dx = x1 - x0, dy = y1 - y0, n = Math.min(24, Math.round(Math.hypot(dx, dy) / step));
      var ang = Math.atan2(dy, dx), ph = rnd(0, 6.28), amp = rnd(.15, .4);
      var color = Math.random() < .7 ? GOLD : SAGE, op = color === GOLD ? .62 : .55;
      var x = x0, y = y0, i = 0;
      (function walk() {
        if (!alive()) return;
        if (i >= n) { setTimeout(trail, rnd(500, 1600)); return; }
        var a = ang + amp * Math.sin(i * .45 + ph);
        x += Math.cos(a) * step; y += Math.sin(a) * step;
        var off = (i % 2 ? 1 : -1) * s * .36;
        paw(x + Math.cos(a + Math.PI / 2) * off, y + Math.sin(a + Math.PI / 2) * off, a * 57.2958 + 90, s, color, op, 3400);
        i++;
        setTimeout(walk, 380);
      })();
    }
    setTimeout(trail, 300);
    setTimeout(trail, 2300);
    setTimeout(trail, 4600);

    /* Étoiles qui scintillent */
    for (var k = 0; k < 9; k++) {
      var sp = document.createElement('i');
      sp.className = 'pw-spark';
      sp.textContent = '✦';
      sp.style.cssText = 'left:' + rnd(4, 96) + '%;top:' + rnd(6, 94) + '%;--d:' + rnd(2.6, 4.8) + 's;animation-delay:' + (-rnd(0, 4)) + 's;font-size:' + rnd(10, 20) + 'px';
      layer.appendChild(sp);
    }

    /* Le curseur laisse des pattes derrière lui */
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      var lx = null, ly = null, acc = 0, alt = 1;
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        if (lx !== null) {
          var dx = x - lx, dy = y - ly, d = Math.hypot(dx, dy);
          acc += d;
          if (acc > 90 && d > 0) {
            acc = 0; alt = -alt;
            var a = Math.atan2(dy, dx);
            paw(x + Math.cos(a + 1.5708) * alt * 13, y + Math.sin(a + 1.5708) * alt * 13, a * 57.2958 + 90, Math.max(32, size() * .75), GOLD, .7, 1900);
          }
        }
        lx = x; ly = y;
      });
      hero.addEventListener('mouseleave', function () { lx = null; acc = 0; });
    }

    /* Un clic ou un tap fait trotter trois pattes */
    hero.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('a,button')) return;
      var r = hero.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      var a = rnd(-2.6, -.5), s = Math.max(32, size() * .8);
      for (var j = 0; j < 3; j++) {
        (function (j) {
          setTimeout(function () {
            var off = (j % 2 ? 1 : -1) * 12;
            paw(x + Math.cos(a) * j * s * 1.5 + Math.cos(a + 1.5708) * off, y + Math.sin(a) * j * s * 1.5 + Math.sin(a + 1.5708) * off, a * 57.2958 + 90, s, GOLD, .7, 2000);
          }, j * 160);
        })(j);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pawInit);
  else pawInit();
  document.addEventListener('shopify:section:load', pawInit);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chattitude-offer-bar"]) return;
  try {
    
(function () {
  'use strict';
  function obInit() {
    var root = document.getElementById('ct-offerbar');
    if (!root || root.getAttribute('data-ob')) return;
    root.setAttribute('data-ob', '1');
    var toggle = root.querySelector('.ob-btn'), panel = root.querySelector('.ob-panel');
    var closer = root.querySelector('.ob-x'), form = root.querySelector('form');
    var hd = document.getElementById('ct-header') || document.querySelector('header');
    if (!toggle || !panel) return;

    /* L'en-tête fixe se cale sous le bandeau, puis remonte quand le bandeau sort de l'écran.
       La position est donnée par la variable --ct-bar-b (bas du bandeau) ; le calcul final se fait en CSS,
       en tenant compte de la zone sous la barre d'état des téléphones. */
    function fit() {
      if (!hd) return;
      if (window.getComputedStyle(hd).position !== 'fixed') { hd.style.removeProperty('--ct-bar-b'); return; }
      var b = root.getBoundingClientRect().bottom;
      hd.style.setProperty('--ct-bar-b', (b > 0 ? b : 0) + 'px');
    }
    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('ob-open', open);
      fit();
      if (open) {
        var f = root.querySelector('.ob-email');
        if (f && f.offsetParent !== null) { try { f.focus({ preventScroll: true }); } catch (err) { /* ignoré */ } }
      }
    }
    toggle.addEventListener('click', function () { setOpen(panel.hidden); });
    if (closer) closer.addEventListener('click', function () { setOpen(false); toggle.focus(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); }
    });
    window.addEventListener('scroll', fit, { passive: true });
    window.addEventListener('resize', fit);
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(root);
    fit();

    /* Maquette : sur le site de présentation, le formulaire affiche le code sans enregistrer l'e-mail */
    if (form && form.getAttribute('data-demo') === '1') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fields = form.querySelector('.ob-fields'), ok = form.querySelector('.ob-ok');
        if (fields) fields.hidden = true;
        if (ok) ok.hidden = false;
      });
    }

    var btn = root.querySelector('[data-ob-copy]');
    if (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-ob-copy'), label = btn.textContent;
        function done() { btn.textContent = 'Copié'; setTimeout(function () { btn.textContent = label; }, 1800); }
        function pick() {
          var el = root.querySelector('.ob-code b');
          if (!el) return;
          var r = document.createRange(), s = window.getSelection();
          r.selectNodeContents(el); s.removeAllRanges(); s.addRange(r);
          try { document.execCommand('copy'); done(); } catch (err) { /* le code reste sélectionné */ }
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, pick);
        } else { pick(); }
      });
    }

    /* Retour de Shopify après l'inscription : on rouvre le bandeau pour montrer le code */
    if (/customer_posted=true/.test(window.location.search) && window.location.hash === '#ct-offer-form') {
      setOpen(true);
      try { root.scrollIntoView({ block: 'start' }); } catch (err) { /* ignoré */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', obInit);
  else obInit();
  document.addEventListener('shopify:section:load', obInit);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chattitude-welcome"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function wlInit() {
    var root = document.getElementById('ct-bienvenue');
    if (!root || root.getAttribute('data-wl')) return;
    root.setAttribute('data-wl', '1');
    root.classList.add('wl-js');
    function reveal() { root.classList.add('wl-in'); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { reveal(); io.disconnect(); }
      }, { threshold: 0.15 });
      io.observe(root);
    } else { reveal(); }

    var form = root.querySelector('form');
    /* Maquette : sur le site de présentation, le formulaire affiche le code sans enregistrer l'e-mail */
    if (form && form.getAttribute('data-demo') === '1') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fields = form.querySelector('.wl-fields'), ok = form.querySelector('.wl-ok');
        if (fields) fields.hidden = true;
        if (ok) { ok.hidden = false; reveal(); }
      });
    }

    var btn = root.querySelector('[data-wl-copy]');
    if (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-wl-copy'), label = btn.textContent;
        function done() { btn.textContent = 'Copié'; setTimeout(function () { btn.textContent = label; }, 1800); }
        function pick() {
          var el = root.querySelector('.wl-code b');
          if (!el) return;
          var r = document.createRange(), s = window.getSelection();
          r.selectNodeContents(el); s.removeAllRanges(); s.addRange(r);
          try { document.execCommand('copy'); done(); } catch (err) { /* le code reste sélectionné */ }
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, pick);
        } else { pick(); }
      });
    }

    if (/customer_posted=true/.test(window.location.search)) {
      reveal();
      if (window.location.hash !== '#ct-offer-form') {
        try { root.scrollIntoView({ block: 'center' }); } catch (err) { /* ignoré */ }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wlInit);
  else wlInit();
  document.addEventListener('shopify:section:load', wlInit);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
